// src/components/preview/income/IncomeResolutionPreview.jsx
// ✅ 수입결의서(WEHAGO 양식) 미리보기 — 지출결의(ExpenseResolutionPreview.jsx)와
// 완전 대칭. 실제 렌더링/필드 매핑 로직은 ResolutionPreview.jsx(지출/수입 결의
// 공용)를 그대로 재사용하고, 여기서는 수입결의 쪽 prop 이름(depositDate)과
// buildIncomeResolutionProps 반환 형태만 감싸는 얇은 래퍼.
import React from "react";
import ResolutionPreview, { buildResolutionProps } from "../resolution/ResolutionPreview";

export function buildIncomeResolutionProps(doc) {
  const p = buildResolutionProps(doc);
  return { ...p, depositDate: p.transactionDate, payMethodLabel: p.methodLabel };
}

export default function IncomeResolutionPreview({ depositDate, payMethodLabel, ...rest }) {
  return (
    <ResolutionPreview
      {...rest}
      kind="income"
      transactionDate={depositDate}
      methodLabel={payMethodLabel}
    />
  );
}
